import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ReferenceData {
  index: number;
  type_code: string;
  type_value: string;
  valid?: boolean;
}
@Component({
  selector: 'app-add-reference',
  templateUrl: './add-reference.component.html',
  styleUrls: ['./add-reference.component.css'],
})
export class AddReferenceComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<ReferenceData>();
  displayedColumns = ['type_code', 'type_value', 'action'];
  ftritnCode = 'FTR/ITN';
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      referenceData: ReferenceData[];
    },
    private dialogRef: MatDialogRef<AddReferenceComponent>
  ) {}

  ngOnInit(): void {
    if (this.data.referenceData.length == 0) {
      this.data.referenceData = [
        { index: 0, type_code: this.ftritnCode, type_value: '' },
        { index: 1, type_code: 'MRN', type_value: '' },
      ];
    } else if (
      this.data.referenceData.length == 1 &&
      this.data.referenceData.filter(d => d.type_code == this.ftritnCode).length
    ) {
      this.data.referenceData.push({ index: 1, type_code: 'MRN', type_value: '' });
    } else if (
      this.data.referenceData.filter(d => d.type_code == this.ftritnCode).length == 0 &&
      this.data.referenceData.filter(d => d.type_code == 'MRN').length
    ) {
      this.data.referenceData.unshift({ index: 1, type_code: this.ftritnCode, type_value: '' });
    }

    this.dataSource.data = this.data.referenceData.map((d, i) => {
      return {
        ...d,
        index: i,
      };
    });
  }

  closeDialog() {
    if (this.dataSource.data.filter(e => e.valid == false).length > 0) {
    } else {
      this.dialogRef.close({ data: this.dataSource.data.filter(d => d.type_value !== '') });
    }
  }

  remove(invoiceRef: ReferenceData): void {
    const index = this.dataSource.data.indexOf(invoiceRef);
    if (index >= 0) {
      this.dataSource.data.splice(index, 1);
      this.dataSource.data = this.dataSource.data.map((d, i) => {
        return {
          ...d,
          index: i,
        };
      });
      this.dataSource._updateChangeSubscription();
    }
  }
  Add(): void {
    let len = this.dataSource.data.length;
    this.dataSource.data.push({ index: len, type_code: 'MRN', type_value: '' });
    this.dataSource._updateChangeSubscription();
  }

  onValidate(e: boolean, row: any) {
    row.valid = e;
  }
}
